<template>

    <b-row align-v="center" class="login-cover-caption">

        <b-col align-self="center" cols="3" style="max-width: 320px">

            <img src="/img/login/login-logo.png" 
				 class="form-signin-heading" 
				 alt="Май" />
            
            <b-row class="mb-15">
                <b-input v-model="password"
                         type="password" 
                         placeholder="Новый пароль" />
            </b-row>

            <b-row class="mb-15">
                <b-input v-model="replayPassword" 
                         type="password"
                         placeholder="Повторите новый пароль" />
            </b-row>


            <button class="btn btn-lg btn-success btn-block medium" 
					type="submit" 
					@click="reset">

				Изменить пароль
			</button>

        </b-col>

    </b-row>

</template>

<script>

import dialogService from '@/services/dialog.service'
import apiService from '@/services/api.service'

import allRoutes from '@/routes/all.routes'

export default {
    data: function() {            
        return {
            password: null,
            replayPassword: null
        }
    },
    methods: {
        reset: function() {
            if(this.password != this.replayPassword) {
                return dialogService.showAlert('Предупреждение', 'Введенные пароли не совпадают')
            }

            let resetPasswordDto = {
                Code: this.$route.query.code,
                UserId: this.$route.query.userId, 
                Password: this.password
            };
                        
            apiService.Account.PostResetPassword(resetPasswordDto)
                .then(response => {
                    this.$router.push(allRoutes.Account.Login);
                })
                .catch(error => console.log(error));
        }
    }
}
</script>